import { createApp } from 'vue';
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
// import './style.css';
import './styles/index.scss';
import router from './router/index.ts';
import App from './App.vue';
import Footer from './components/Footer.vue';
import '@/styles/academic-colors.scss'
import { useAuthStore } from './stores/auth.ts';
import "maplibre-gl/dist/maplibre-gl.css";
const app = createApp(App);
const pinia = createPinia();
// 确保先使用路由
app.use(pinia)   // ⬅️ 一定要在任何 useAuthStore() 之前


// 确保进入首屏前恢复登录态
const auth = useAuthStore()
auth.initFromStorage()
// 路由守卫
router.beforeEach((to, from, next) => {
  const auth = useAuthStore()

  const needAuth = to.matched.some(r => r.meta?.requiresAuth)
  const isGuestOnly = to.matched.some(r => r.meta?.requiresGuest)

  if (needAuth && !auth.isAuthed) {
    // 未登录访问受限页 → 跳登录，并带上回跳地址
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else if (isGuestOnly && auth.isAuthed) {
    // 已登录不允许进登录/注册页
    next({ path: '/' })
  } else {
    next()
  }
})

app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});

app.component('Footer', Footer);

Object.keys(ElementPlusIconsVue).forEach((key) => {
  app.component(key, (ElementPlusIconsVue as { [key: string]: any })[key]);
});

app.mount('#app');